// Mapa de CP → cluster de precio basado en datos reales de transacciones
const CP_CLUSTER = {
  '03130': 'santa_pola',
  '03140': 'guardamar',
  '03169': 'algorfa',
  '03170': 'rojales',
  '03177': 'san_fulgencio',
  '03178': 'benijofar',
  '03179': 'rojales',
  '03180': 'torrevieja',
  '03181': 'torrevieja',
  '03182': 'torrevieja',
  '03183': 'torrevieja',
  '03184': 'torrevieja',
  '03185': 'torrevieja',
  '03186': 'torrevieja',
  '03189': 'orihuela_costa',
  '03190': 'pilar',
  '03191': 'pilar',
  '03193': 'san_miguel',
  '03194': 'la_marina',
  '03200': 'elche',
  '03201': 'elche',
  '03202': 'elche',
  '03203': 'elche',
  '03300': 'orihuela',
  '03301': 'orihuela',
  '03310': 'orihuela',
  '03314': 'orihuela',
  '03319': 'orihuela',
  '30007': 'murcia',
  '30009': 'murcia',
  '30010': 'murcia',
  '30107': 'murcia',
  '30110': 'murcia',
  '30202': 'cartagena',
  '30203': 'cartagena',
  '30368': 'mar_cristal',
  '30384': 'mar_cristal',
  '30500': 'molina',
  '30506': 'molina',
  '30508': 'molina',
  '30509': 'molina',
  '30560': 'ceuti',
  '30562': 'ceuti',
  '30590': 'sucina',
  '30709': 'roldan',
  '30710': 'los_alcazares',
  '30711': 'los_alcazares',
  '30720': 'san_javier',
  '30730': 'san_javier',
  '30739': 'san_javier',
  '30740': 'san_pedro',
  '30741': 'san_pedro',
};

// Nombres legibles de los clusters
export const CLUSTER_NAMES = {
  torrevieja:     'Torrevieja',
  orihuela_costa: 'Orihuela Costa / La Zenia',
  pilar:          'Pilar de la Horadada / Torre',
  san_miguel:     'San Miguel de Salinas',
  la_marina:      'La Marina / El Pinet',
  algorfa:        'Algorfa',
  rojales:        'Rojales / Ciudad Quesada',
  san_fulgencio:  'San Fulgencio',
  benijofar:      'Benijófar',
  guardamar:      'Guardamar del Segura',
  santa_pola:     'Santa Pola / Gran Alacant',
  orihuela:       'Orihuela / Jacarilla',
  elche:          'Elche',
  los_alcazares:  'Los Alcázares',
  san_javier:     'San Javier / Santiago Ribera',
  san_pedro:      'San Pedro del Pinatar / Lo Pagán',
  ceuti:          'Ceuti / Alguazas',
  sucina:         'Sucina',
  molina:         'Molina de Segura',
  mar_cristal:    'Mar de Cristal / Los Urrutias',
  roldan:         'Roldán',
  murcia:         'Murcia',
  cartagena:      'Cartagena',
};

// Precios reales observados (min, max) por cluster y tipo de servicio
// null = sin datos suficientes para ese cluster y tipo
const CLUSTER_PRICES = {
  torrevieja:     { acs110:[105,142], acs150:[125,179], acs250:[179,179], conductos:null,      caldera:[142,148] },
  orihuela_costa: { acs110:[110,168], acs150:[153,175], acs250:null,      conductos:[167,168], caldera:[136,162] },
  pilar:          { acs110:[105,160], acs150:[125,153], acs250:null,      conductos:[157,180], caldera:null      },
  san_miguel:     { acs110:[198,198], acs150:null,      acs250:null,      conductos:null,      caldera:null      },
  la_marina:      { acs110:[154,208], acs150:null,      acs250:null,      conductos:[208,208], caldera:null      },
  algorfa:        { acs110:[127,153], acs150:[147,147], acs250:null,      conductos:null,      caldera:null      },
  rojales:        { acs110:[127,148], acs150:null,      acs250:null,      conductos:null,      caldera:null      },
  san_fulgencio:  { acs110:[127,153], acs150:[153,153], acs250:null,      conductos:null,      caldera:null      },
  benijofar:      { acs110:[127,153], acs150:null,      acs250:null,      conductos:null,      caldera:null      },
  guardamar:      { acs110:[148,148], acs150:null,      acs250:null,      conductos:null,      caldera:null      },
  santa_pola:     { acs110:[154,154], acs150:null,      acs250:null,      conductos:null,      caldera:null      },
  orihuela:       { acs110:[148,148], acs150:null,      acs250:null,      conductos:null,      caldera:[148,148] },
  elche:          { acs110:[154,154], acs150:null,      acs250:null,      conductos:null,      caldera:[154,154] },
  los_alcazares:  { acs110:[121,121], acs150:null,      acs250:null,      conductos:null,      caldera:null      },
  san_javier:     { acs110:[107,121], acs150:null,      acs250:null,      conductos:[185,185], caldera:null      },
  san_pedro:      { acs110:[107,108], acs150:null,      acs250:null,      conductos:null,      caldera:null      },
  ceuti:          { acs110:[139,139], acs150:null,      acs250:null,      conductos:null,      caldera:null      },
  sucina:         { acs110:[181,181], acs150:null,      acs250:null,      conductos:[181,181], caldera:null      },
  molina:         { acs110:[159,159], acs150:[159,159], acs250:null,      conductos:null,      caldera:[160,160] },
  mar_cristal:    { acs110:[130,130], acs150:null,      acs250:null,      conductos:null,      caldera:null      },
  roldan:         { acs110:[128,128], acs150:null,      acs250:null,      conductos:null,      caldera:null      },
  murcia:         { acs110:[186,186], acs150:[153,164], acs250:null,      conductos:null,      caldera:null      },
  cartagena:      { acs110:null,      acs150:[147,147], acs250:null,      conductos:null,      caldera:null      },
};

const DEFAULTS = {
  acs110:[105,210], acs150:[125,180], acs250:[179,220],
  conductos:[157,210], caldera:[136,165],
};

function getAcsTier(litrajeField) {
  if (litrajeField === '250_mas') return 'acs250';
  if (litrajeField === '150_200') return 'acs150';
  return 'acs110';
}

function getAcsTierFromModelo(modelo) {
  if (!modelo) return 'acs110';
  const nums = (modelo.match(/\b(\d{2,3})\b/g) || []).map(Number);
  const liters = nums.find(n => n >= 50 && n <= 400);
  if (liters >= 200) return 'acs250';
  if (liters >= 150) return 'acs150';
  return 'acs110';
}

// Returns { min, max, clusterName, fromData } or null
export function estimarPrecio(codigoPostal, tipoEquipo, litrajeTermoMTO, modelo) {
  const clusterId = CP_CLUSTER[codigoPostal] || null;
  const prices    = clusterId ? (CLUSTER_PRICES[clusterId] || DEFAULTS) : DEFAULTS;
  const name      = clusterId ? (CLUSTER_NAMES[clusterId] || clusterId) : null;

  let key;
  switch (tipoEquipo) {
    case 'termo_electrico': {
      const tier = litrajeTermoMTO ? getAcsTier(litrajeTermoMTO) : getAcsTierFromModelo(modelo);
      key = tier;
      break;
    }
    case 'conductos':
    case 'aerotermo_conductos':
      key = 'conductos';
      break;
    case 'caldera':
      key = 'caldera';
      break;
    default:
      return null; // split y aerotermo: sin datos suficientes aún
  }

  const range = prices[key] || DEFAULTS[key] || null;
  if (!range) return null;
  return {
    min: range[0],
    max: range[1],
    clusterName: name,
    fromData: !!clusterId,
  };
}

export function getCluster(codigoPostal) {
  const id = CP_CLUSTER[codigoPostal] || null;
  return id ? { id, name: CLUSTER_NAMES[id] || id } : null;
}
